import { useState } from "react";

function FuturesAndOptionsModule() {
  const [activeModule, setActiveModule] = useState(null);

  const toggleModule = (index) => {
    setActiveModule(activeModule === index ? null : index);
  };

  const modules = [
    {
      title: "Module 1: Introduction to Derivatives",
      content: [
        "Overview of Futures and Options as financial derivatives.",
        "Purpose and usage in trading and hedging.",
      ],
    },
    {
      title: "Module 2: Understanding Futures Contracts",
      content: [
        "Definition, structure, and mechanics of Futures contracts.",
        "Expiration dates, contract size, and margin requirements.",
      ],
    },
    {
      title: "Module 3: Futures Market Participants",
      content: [
        "Roles of hedgers, speculators, and arbitrageurs.",
        "How different participants impact the market.",
      ],
    },
    {
      title: "Module 4: Types of Futures Contracts",
      content: [
        "Equity, commodity, currency, and interest rate futures.",
        "Key differences and how they are traded.",
      ],
    },
    {
      title: "Module 5: Introduction to Options Contracts",
      content: [
        "Calls and Puts explained.",
        "Rights and obligations in Options contracts.",
      ],
    },
    {
      title: "Module 6: How Options Work",
      content: [
        "Strike price, expiration date, premium, and intrinsic value.",
        "Understanding how Options are priced.",
      ],
    },
    {
      title: "Module 7: Basic Options Strategies",
      content: [
        "Covered Call, Protective Put, and Cash-Secured Put strategies.",
        "When and why to use these basic strategies.",
      ],
    },
    {
      title: "Module 8: Advanced Options Strategies",
      content: [
        "Iron Condors, Butterflies, Straddles, and Strangles.",
        "Complex strategies for experienced traders.",
      ],
    },
    {
      title: "Module 9: The Greeks",
      content: [
        "Delta, Gamma, Theta, Vega, and Rho explained.",
        "How to use the Greeks for Options trading.",
      ],
    },
    {
      title: "Module 10: Risk Management in Futures & Options",
      content: [
        "Position sizing, stop-loss orders, and risk-reward ratio.",
        "Using Futures and Options to hedge other investments.",
      ],
    },
    {
      title: "Module 11: Market Sentiment & Volatility",
      content: [
        "How to interpret market sentiment and the VIX.",
        "The impact of volatility on pricing and trading decisions.",
      ],
    },
    {
      title: "Module 12: Futures vs Options: Key Differences",
      content: [
        "Obligations vs. rights: the primary distinction.",
        "Risk profiles, liquidity, and costs of Futures vs. Options.",
      ],
    },
    {
      title: "Module 13: Using Futures & Options Together",
      content: [
        "Combining Futures and Options for advanced trading strategies.",
        "Hedging, speculation, and portfolio protection.",
      ],
    },
    {
      title: "Module 14: Trading Psychology in Futures & Options",
      content: [
        "Managing emotions, overtrading, and mental discipline.",
        "The importance of patience and planning.",
      ],
    },
    {
      title: "Module 15: Mastering the Art of Futures and Options",
      content: [
        "Developing a personalized trading plan.",
        "Continuous learning, backtesting strategies, and simulating trades.",
      ],
    },
  ];

  return (
    <div className="container py-5">
      <h1 className="text-center mb-5">Art of Futures and Options</h1>
      <div className="accordion">
        {modules.map((module, index) => (
          <div key={index} className="mb-3">
            <div
              className="p-3 bg-primary text-white d-flex justify-content-between align-items-center"
              onClick={() => toggleModule(index)}
              style={{
                cursor: "pointer",
                borderRadius: "5px",
              }}
            >
              <h5 className="m-0">{module.title}</h5>
              <span
                style={{
                  fontSize: "18px",
                  transform: activeModule === index ? "rotate(180deg)" : "rotate(0deg)",
                  transition: "transform 0.3s ease",
                }}
              >
                ▼
              </span>
            </div>
            {activeModule === index && (
              <div
                className="p-3 bg-light border"
                style={{ borderRadius: "5px" }}
              >
                {module.content.map((item, i) => (
                  <p key={i} style={{ margin: "5px 0", fontSize: "14px" }}>
                    ➤ {item}
                  </p>
                ))}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}

export default FuturesAndOptionsModule;
